<template>
  <div class="d-none">
    <qr-code-make
      ref="qrCanvas"
      v-model="qrDesign"
      :file.sync="qrSvgDataUrl"
      :link="fullLink"
      @save="qrDesign = $event"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Bus, debounce } from "@/main";
import QrCodeMake from "../../qrland/qrCodeStyle/qrCodeMake.vue";
import { getLanguageCookie } from "@/core/plugins/TitleRibbon/utils/languageCookie";
import { setDragging } from "@/utilities/DraggingKeysOrder";

export default {
  name: "NfcAutoAssigner",
  components: {
    QrCodeMake,
  },

  data() {
    return {
      previewKey: 0,
      showAiDialog: false,
      cardTexts: {
        pallete: {
          headColor: "linear-gradient(to right , #1AD6D8FF, #7915A7FF)",
          bodyColor: "linear-gradient(to top left , #9AFEFFFF, #DF99FFFF)",
          textColor: "#ffffff",
          borderColor: "#393939",
          isDarkBody: false,
        },
        visitName: "کیوآر لند/کارت ویزیت الکترونیکی",
        isGradient: true,
        organizationName: "کیوآر لند",
        subOrgan: "اولین سامانه ساخت کیوآر داینامیک",
        userName: "کارت ویزیت الکترونیکی",
        workField: null,
        phoneNumber: [
          { number: "90007425", text: "" },
          { number: "02191017077" },
        ],
        extraFields: [
          {
            icon: "mdi-card-account-details",
            name: "",
            value:
              "\n🟥مشابه همین کارت ویزیت الکترونیکی را برای کسب و کار خود بسازید.\n🟧3 روز رایگان تست کنید.\n🟨برای ثبت نام رایگان کلیک کنید.",
            type: "link",
            link: "https://qrland.ir",
          },
          {
            icon: "mdi-qrcode-edit",
            name: "",
            value:
              "کارت ویزیت الکترونیکی شما دارای كيوار دايناميك است.\nدر هر زمان ميتوانيد با موبایل خود اطلاعات را ویرایش کنید.\nكيوآر كد شما هيچگاه پس از ویرایش تغيير نميكند.",
          },
          {
            icon: "",
            name: "",
            value: "💲هزینه داشتن این کارت ویزیت 900هزار تومان است.",
          },
          {
            icon: "",
            name: "",
            value: "",
            label: "",
            type: "icon",
          },
        ],
        companyNumber: "02191017077",
        email: "info@qrland.com",
        fax: "فکس 02191016066",
        location:
          "تهران، خیابان شریعتی\nبعد از پل سید خندان، بن بست خندان ، پلاک 6 ",
        city: "",
        photo: {
          PicSelector: {
            slider: true,
            grid: false,
            orientation: "horizontal",
          },
          profile: "https://cdn.terminalads.com/upload/64b11ae97aae0.webp",
          transition: "scale",
          hasWelcome: false,
          headBackground: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
          gallery: [
            {
              name: "ما همیشه کنار شما خواهیم ماند...",
              images: [
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_possibilities",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af06f647f05.webp",
                  description: "",
                  link: "",
                  id: 1147899,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_possibilities",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
                  description: "",
                  link: "",
                  id: 1147900,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_features_of_clearer_QR_code",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af07463ae3d.webp",
                  description: "",
                  link: "",
                  id: 1147902,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_features_of_clearer_QR_code",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af072f1425c.webp",
                  description: "",
                  link: "",
                  id: 1147901,
                },
              ],
            },
          ],
          hasGif: false,
          hasGame: false,
          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        codePostal: "کد پستی 1541946815",
        province: "",
        country: "",
        website: "www.qrland.ir",
        socialMedia: {
          address: [
            {
              hint: " لطفا آدرس آدرس خودرا وارد کنید ",
              label: "آدرس",
              url: "www.qrland.ir",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
              prefix: "URL",
              pattern: "",
            },
            {
              hint: " لطفا آدرس آدرس خودرا وارد کنید ",
              label: "آدرس",
              url: "www.qr.terminalads.com",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
              prefix: "URL",
              pattern: "",
            },
          ],
          instagram: [
            {
              hint: " لطفا آدرس اینستاگرام خودرا وارد کنید ",
              label: "اینستاگرام",
              url: "https://instagram.com/terminalads",
              img: "/media/socialIcon/40icon/instagram.svg",
              svg: "svgInstagram",
              prefix: "@",
              pattern: "https://instagram.com/",
            },
          ],
          whatsapp: [
            {
              hint: " لطفا آدرس واتساپ خودرا وارد کنید ",
              label: "واتساپ",
              url: "+982191017077",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              svg: "svgWhatsapp",
              prefix: "mdi-phone",
              pattern: "https://wa.me/",
            },
          ],
        },
        aboutUs:
          'باتوجه به مشکلات موجود در کارت ویزیت فیزیکی\nسامانه کیوآر لند محصولی به نام "کارت ویزیت الکترونیکی"\nرا ارائه نموده است.\nو با استفاده از تکنولوژی های دیجیتالی\nتوانسته مشکلات و محدودیت های موجود در\nکارت ویزیت های فیزیکی را به طور کامل برطرف نماید.\nهمزمان، با جایگزین کردن هوشمندی، از قطع بی رویه درختان جلوگیری کنید.',
        coordinates: [51.44664929903732, 35.743057774101274],
        address:
          "ایران، تهران، شهر تهران، تهران، منطقه ۳ شهر تهران، محله سید خندان، دکتر علی شریعتی، خندان",
        apiKey: "GAPGPTMASKTOKENhqfseew138uX0X",
        video_gallery: [
          {
            name: "",
            images: [
              {
                name: "چرا کارت ویزیت کیو آر لند؟ کیو آر لند با بقیه چه فرقی داره؟",
                title: "چرا کارت ویزیت کیوآر لند",
                file_link:
                  "https://www.aparat.com/video/video/embed/videohash/okn5zhp/vt/frame",
                description: "",
                link: "",
                id: 456,
              },
              {
                name: "معرفی کارت ویزیت الکترنیکی کیوآر لند",
                title: "بهترین جایگزین کارت ویزیت فیزیکی",
                file_link:
                  "https://www.aparat.com/video/video/embed/videohash/zmyd3vb/vt/frame",
                description: "",
                link: "",
                id: 267,
              },
            ],
          },
        ],
        customerClub: {
          configs: {
            patternId: 499,
            smsType: "pattern",
            isActive: true,
            message: {
              data1: {
                text: "name",
                state: "userInfo",
              },
              data2: {
                text: "lastName",
                state: "userInfo",
              },
            },
          },
          title: "عضویت در باشگاه مشتریان",
          description: "این یک باشگاه مشتریان عادی نیست!\nشمارتو ثبت کن",
        },
        advanceSettings: {
          viewConfigs: {
            autoCsvDownload: false,
            showCClubOnload: false,
            forcedSubmission: "optional",
          },
          hasManifestIcons: true,
          manifest: {
            icon48: "https://cdn.terminalads.com/upload/67d49c914b6d1.webp",
            icon144: "https://cdn.terminalads.com/upload/67d49c918fa23.webp",
            screenshotWide: "",
            screenshot600: "",
          },
          hasAssistants: false,
          aiChatConfig: {
            assistant: {},
          },
        },
        tab_design: 1,
        audiosGallery: {
          audios: [
            {
              id: 1941300,
              category: "همه",
              title: "راهنمای جامع کارت ویزیت الکترونیکی",
              md5: "0cf572d4e658fe4ca5345f52677d08da",
              path: "upload/686a93cf44e5c.wav",
              type: "other",
              file_type: "audio",
              created_at: "2025-07-06T15:18:39.000000Z",
              updated_at: "2025-07-06T15:18:39.000000Z",
              full_path: "https://cdn.terminalads.com/upload/686a93cf44e5c.wav",
              created_at_p: "1404-04-15 18:48:39",
              updated_at_p: "1404-04-15 18:48:39",
              created_at_diff: "1 ثانیه پیش",
              updated_at_diff: "1 ثانیه پیش",
              autoPlay: false,
            },
          ],
          audioType: "newPlayer",
        },
        language: "fa",
        langs: {
          source_lang: "fa",
          other_langs: [
            { lang: "en_US", status: "edited" },
            { lang: "en_GB", status: "edited" },
            { lang: "ar", status: "edited" },
            { lang: "ar_iq", status: "edited" },
            { lang: "de", status: "edited" },
            { lang: "fr", status: "edited" },
            { lang: "hy", status: "edited" },
            { lang: "ru", status: "edited" },
            { lang: "tr", status: "edited" },
            { lang: "zh_CN", status: "edited" },
            { lang: "zh_TW", status: "edited" },
            { lang: "ar_ae", status: "edited" },
          ],
        },
      },
      orders: [
        { name: "userName" },
        { name: "aboutUs" },
        { name: "extraFields" },
        { name: "photo" },
        { name: "phoneNumber" },
        { name: "fax" },
        { name: "location" },
        { name: "codePostal" },
        { name: "email" },
        { name: "website" },
        { name: "tab_design" },
        { name: "audio_0" },
      ],
      theme: "MobileViwer",
      showconnect: false,
      connectionCode: null,
      loadingconnetion: false,
      helpData: [],
      svgMade: "",
      componentName: "cardVisit",
      serviceName: "Qrland",
      info: null,
      qrDesign: {},
      e6: 1,
      errors: {},
      createdId: null,
      createdDomain: null,
      ready: false,
      loading: false,
      showDialog: false,
      dtUrl: null,
      domainId: 5,
      qrShow: 1,
      qrSvgDataUrl: "",

      // متغیرهای کمکی برای تخصیص NFC
      currentItem: null,
      isAutoCycle: false,
      processResolve: null,
      processReject: null,
    };
  },

  computed: {
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.updateTransition();
    this.setKeys(this.cardTexts);
  },

  watch: {
    cardTexts: {
      deep: true,
      handler(newVal) {
        debounce(() => {
          this.setKeys(newVal);
        }, 300);
      },
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),

    process(item, isAutoCycle = false) {
      return new Promise((resolve, reject) => {
        if (!item) {
          reject(new Error("آیتم نامعتبر است"));
          return;
        }

        this.currentItem = item;
        this.isAutoCycle = isAutoCycle;
        this.processResolve = resolve;
        this.processReject = reject;

        this.e6 = 1;
        this.dtUrl = `CardVisit_${item.id}`;
        this.cardTexts.visitName = `کارت_${item.title || "بدون_عنوان"}_${item.id}`;

        // شروع چرخه ساخت
        this.markQr();
      });
    },

    markQr() {
      this.loading = true;
      this.cardTexts.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";
      this.cardTexts.langs = {
        source_lang: this.cardTexts.language,
        other_langs: [],
      };
      let obj = {
        type: "VisitCard",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
          orders: this.orders,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (!!this.connectionCode) obj.special_code = this.connectionCode;

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.createdId = data.data.identifier;
          this.createdDomain =
            this.$refs["address-field"]?.destItems?.find(
              (item) => item.id === this.domainId
            )?.name ||
            data.data?.domain?.name ||
            "qrland.in/";
          this.info = data.data;
          this.qrShow = 0;
          if (this.setCreatedQrID) {
            this.setCreatedQrID(data.data.id);
          }

          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          this.loading = false;

          // ۱. تشخیص و استخراج خطای تکراری بودن identifier
          let errorMsg = "خطا در ایجاد کیوآر کد";
          const resData = error?.response?.data;
          const isDuplicate = !!resData?.errors?.identifier;

          if (isDuplicate) {
            errorMsg = `این آدرس قبلاً ساخته شده است. لطفاً چک کنید. شناسه: [${this.dtUrl}]`;
          } else if (resData?.message) {
            errorMsg = resData.message;
          }
          const toastTimeout = isDuplicate ? 8000 : 4000;

          if (this.$toast?.error) {
            this.$toast.error(errorMsg, { timeout: toastTimeout });
          } else if (Bus) {
            Bus.$emit("notification", { text: errorMsg, color: isDuplicate ? "warning" : "error",
              timeout: toastTimeout,
            });
          } else {
            alert(errorMsg);
          }

          this.$emit("error", { item: this.currentItem, isAutoCycle: this.isAutoCycle, error, identifier: this.dtUrl,message: errorMsg, isDuplicate: isDuplicate, errorType: isDuplicate ? "DUPLICATE_IDENTIFIER" : "STORE_ERROR",
          });

          if (this.processReject) {
            this.processReject({message: errorMsg, isDuplicate, item: this.currentItem,
            });
          }
        });
    },

    qrUpdate(final = false) {
      this.loading = true;
      const data = new FormData();
      data.append("type", "VisitCard");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.info.qrId);
      this.cardTexts.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";

      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
          orders: this.orders,
        })
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(async ({ data: updateRes }) => {
          if (updateRes && updateRes.data) {
            this.info = updateRes.data;
          }

          const qrId = this.info.qrId || this.info.id;

          try {
            await this.$api.get(`/v1/testQr/check-for-nfc?qr_id=${qrId}`);
          } catch (e) {}

          const selectPayload = {
            delivery_methode: "company",
            qr_id: qrId,
            province: null,
            city: null,
            address: null,
            postal_code: null,
          };

          const selectRes = await this.$api.post(
            `/v2/select-nfc/${this.currentItem.id}`,
            selectPayload
          );

          this.$emit("success", {
            item: this.currentItem,
            isAutoCycle: this.isAutoCycle,
            response: selectRes.data,
            qrId: qrId,
          });
          if (this.processResolve) this.processResolve({...selectRes.data, qrId:qrId});
        })
        .catch((err) => {
          let updateMsg = "خطا در آپدیت یا تخصیص کارت NFC";
          if (err?.response?.data?.message) {
            updateMsg = err.response.data.message;
          }
          if (this.$toast?.error) {
            this.$toast.error(updateMsg);
          }
          this.$emit("error", {
            item: this.currentItem,
            isAutoCycle: this.isAutoCycle,
            error: err,
            message: updateMsg,
            isAssignError: true, 
            errorType: "ASSIGN_ERROR"
            });
          if (this.processReject) this.processReject(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setKeys(val = this.cardTexts) {
      let keys = setDragging(val, this.orders);
      if (
        val.audiosGallery &&
        val.audiosGallery.audios &&
        val.audiosGallery.audios.length > 0
      ) {
        const audioKeys = val.audiosGallery.audios.map((_, index) => ({
          name: `audio_${index}`,
        }));
        keys = [
          ...keys.filter((key) => !key.name.startsWith("audio_")),
          ...audioKeys,
        ];
      }

      keys = keys.filter((item) => item.name !== "audiosGallery");
      keys = keys.filter(
        (item) => item.name !== "langs" && item.name !== "language"
      );

      this.orders = keys;
      this.$forceUpdate();
    },

    updateTransition() {
      this.cardTexts.userName = this.$t("qrland");
      this.cardTexts.workField = this.$t("dynamic");
      this.cardTexts.aboutUs = this.$t("about_us_text");
      this.cardTexts.location = this.$t("address_text");
      this.cardTexts.visitName = this.$t("visit_card");
      this.cardTexts.organizationName = this.$t("qrland_system");
      this.cardTexts.subOrgan = this.$t("qrland_first_system");

      if (
        this.cardTexts.video_gallery &&
        this.cardTexts.video_gallery.length > 0
      ) {
        this.cardTexts.video_gallery[0].name = this.$t("video_gallery");
      }
      this.cardTexts.socialMedia = {
        address: [
          {
            label: this.$t("address"),
            text: this.$t("enter_site_link"),
            hint: this.$t("enter_site_link"),
            pattern: "",
            prefix: "URL",
            url: "qrland.ir",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
          {
            label: this.$t("address"),
            text: this.$t("enter_site_link"),
            hint: this.$t("enter_site_link"),
            pattern: "",
            prefix: "URL",
            url: "qr.terminalads.com",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
        ],
        instagram: [
          {
            label: this.$t("instagram"),
            text: this.$t("enter_instagram_username"),
            hint: this.$t("enter_instagram_username"),
            pattern: "https://instagram.com/",
            prefix: "@",
            url: "terminalads",
            img: "/media/socialIcon/40icon/instagram.svg",
            svg: "svgInstagram",
          },
        ],
        whatsapp: [
          {
            label: this.$t("whatsapp"),
            text: "+982191017077",
            hint: "+982191017077",
            pattern: "https://wa.me/",
            prefix: "mdi-phone",
            url: "+982191017077",
            img: "/media/socialIcon/40icon/whatsapp.svg",
            svg: "svgWhatsapp",
          },
        ],
      };
    },
  },
};
</script>

   <v-dialog v-model="scannerDialog">
<qr-scanner-component v-if="scannerDialog" @scan="onScanned" />
   </v-dialog>
   
